{
  "0059798b7f7023e4": "(opcional)",
  "04588a6aae45676a": "Díganos qué le gustaría cambiar",
  "0737222a82dd51a8": "CSV o Excel (.xlsx)",
  "07b5d93b0cff13c5": "Solicitud enviada. La revisaremos y nos pondremos en contacto.",
  "0884d6ee37e87a32": "Publicado hace más de {{count}} días antes del inicio del turno",
  "09291fd3a298ea2f": "Eliminar trabajadores",
  "0c370ec3af873d9e": "No se pudieron cargar las calificaciones. Por favor, cierre y vuelva a intentar.",
  "11a6767d5674c7e4": "Hecho",
  "142a2b7bfce29b37": "Salir del modo de selección",
  "17e6c06f18ed21bd": "Enlace al Roster",
  "18beff7fbca20740": "Horas base",
  "18c9a2cfec15c4fd": "Fila {{number}}",
  "19766ed6ccb2f4a3": "Cancelar",
  "1e7986999c544433": "Tu roster ha sido marcado como actualizado",
  "1fc9a387654d410f": "Seleccionar todo",
  "24017c138bb440e0": "No se puede modificar el nombre, teléfono o correo electrónico porque esta información está vinculada al perfil existente de Clipboard de este trabajador.",
  "2707b724bbbb0e20": "¿Algo parece mal? Envía un mensaje a #proj-clipboard-roster con los problemas.",
  "290056e834ccabee": "Editar trabajador",
  "2a78025de6aae5e7": "Seleccionar",
  "2d0dfab0d1858ed7": "Las horas semanales base deben ser un número entre 0 y {{max}}",
  "306f1bb20677a622": "Número de teléfono",
  "309955e00850b8af": "Común",
  "3321b9f6e65c542a": "Fecha agregada",
  "35765e54d942291c": "Error al cargar. Por favor, inténtalo de nuevo.",
  "374e1b8eda8b2676": "Publicado hace menos de {{count}} días antes del inicio del turno",
  "394aac2bde696049": "Encontramos un trabajador coincidente para {{phoneNumber}}",
  "40d92c1dcf20e5a4": "Se abre a su Roster y Clipboard de inmediato.",
  "4479c67aad5130f6": "Carga un archivo CSV o Excel con columnas para Nombre completo, Teléfono, Licencias/cualificaciones y un Email opcional. Puedes añadir hasta {{max}} trabajadores a la vez.",
  "45d157e9b9634c7a": "{{created}} añadidos · {{skipped}} omitidos · {{invalid}} no pudieron ser añadidos",
  "464c4ffd019e1e96": "Editar",
  "47f25f763e0dbcfb": "¿Estás seguro de que quieres salir?",
  "4df6007d82926e3b": "No pudimos leer ese archivo. Carga un archivo CSV o Excel (.xlsx).",
  "509118b69ec228a4": "No se pudo enviar su solicitud. Por favor, inténtelo de nuevo.",
  "514ff9ef71f7b053": "No se pudo actualizar tu roster. Por favor, inténtalo de nuevo.",
  "5316450fd4da39c7": "Perderás tus cambios para este profesional de Roster.",
  "566ca164eea12dbe": "No podrán reservar turnos a través de Roster como miembros del personal interno. Puedes volver a añadirlos en cualquier momento.",
  "61807ec7fd686900": "Busque por nombre, teléfono o correo electrónico.",
  "63dceb8800b2dd4a": "Teléfono",
  "67f46a1d5a5dcd97": "Descargar plantilla CSV",
  "68939dc24dce5ef6": "Publicado {{urgent}}-{{long}} días antes del inicio del turno",
  "6b02e0d363a4af1c": "Agregado",
  "6eea8608c452711b": "Correo electrónico (opcional)",
  "74fa562f32ea8c7d": "El correo electrónico no se puede borrar una vez establecido. Ingresa un nuevo correo electrónico o restaura el anterior.",
  "76dfed04f989a28b": "Este lugar de trabajo no tiene calificaciones configuradas. Contacta al soporte para habilitar la nómina PRN.",
  "78d22b05b5081f52": "Eliminar seleccionados",
  "78d9d31ef4d4f2ae": "¿de tu Roster?",
  "7b4339cf860e01a6": "Calificaciones",
  "7b94628acb624e04": "Arrastra y suelta, o haz clic para elegir un archivo",
  "7eab65b15b80284e": "Este trabajador ya está en tu Roster. Edita el registro existente para actualizar su información.",
  "7f58d87c3a2bc3bc": "No podrán asignarse turnos a través de Roster como miembro del personal interno. Puedes volver a agregarlos en cualquier momento.",
  "80e69fabf23106f4": "{{count}} trabajadores listos para cargar.",
  "83e80546585ea5ad": "Omitido (ya en el Roster)",
  "861b38f2b1ed5692": "Agregar trabajador al equipo",
  "89db19f651b18285": "(requerido)",
  "91b1646d0b92a19a": "No pudimos encontrar trabajadores. Asegúrate de que tu archivo tenga columnas de Nombre completo, Teléfono y Licencias/cualificaciones.",
  "94605bf24653cf87": "¿Eliminar {{count}} {{noun}} de tu Roster?",
  "95f4e8338213e418": "Agregar a Roster",
  "967549497036d513": "Deseleccionar todo",
  "969ccbd3cf6300ec": "Correo electrónico",
  "96cfc37342fa7ddb": "Describa brevemente lo que le gustaría ajustar y por qué.",
  "a1dc12a7788084dd": "ya está en Clipboard con este número de teléfono. ¿Agregarlo a tu Roster?",
  "a5145b2fe67f98b4": "Horas semanales base",
  "aa8be0de6081a385": "No pudimos encontrar trabajadores. Asegúrate de que tu archivo tenga las columnas Nombre completo, Teléfono y Calificaciones.",
  "ad9b0ab77a839caa": "Cargar trabajadores en masa",
  "b13c9ea94acf9b0f": "No se pudo agregar",
  "b9c6d434be0083c0": "Se abre a Clipboard {{count}} días antes del inicio del turno.",
  "bb9c8d03519c80e3": "Marcar el roster como actualizado",
  "bc9a0f00e968cada": "Se abre a Clipboard {{count}} días después de la publicación.",
  "bf180fbea0d8415e": "El roster no se ha actualizado en más de 10 días y puede estar desactualizado",
  "c08431714df238ca": "Eliminar trabajador",
  "c3812fc4acb861d5": "Eliminar",
  "c7f761b38b197daa": "{{count}} seleccionados",
  "c8df66c5fe3f97d0": "Cerrar diálogo",
  "d3d651871073a476": "No hay trabajadores que coincidan con su búsqueda.",
  "d44699007014bc97": "Ventana de lista",
  "d6d2775b0d5824d1": "Sube un archivo CSV o Excel con estas columnas. Puedes agregar hasta {{max}} trabajadores a la vez.",
  "dab1cccf0c8003b3": "Solicitar un cambio",
  "dcd1d5223f73b3a9": "Nombre",
  "dd0ae7a5cbcf2339": "Guardar cambios",
  "e032a95ab3e797fb": "Cargar en masa",
  "e534713dbafc3f36": "Nota de solicitud de cambio",
  "e65d6db2e90987e2": "Elija un archivo para cargar",
  "ea540f069c20ad18": "Ese archivo tiene {{count}} trabajadores. Carga como máximo {{max}} a la vez.",
  "ec3d5ef3ac1e44e7": "Cuán pronto se abren los turnos a los profesionales de Clipboard, después de que su Roster tenga la primera vista.",
  "f13a64ba2fea87ef": "Nombre completo",
  "f13ab872339af3f4": "Cargar {{count}} trabajadores",
  "f6f4688ff23d50c6": "Enviar",
  "f97e9da0e3b879f0": "Otro"
}
